export default "__VITE_ASSET__t_UKuGxL__"